import { Flex, Text } from '@chakra-ui/react';
import Content from './components/content';
import { Link } from 'react-router-dom';

export function UnauthorizedPage() {
    return (
        <Content headerTitle="Insufficient Permissions">
            {{
                content: (
                    <Flex justifyContent="center" alignItems="center" h="100%" w="100%" flexDirection="column" gap="8px">
                        <Text fontSize="18px">Not authorized to view the page requested</Text>
                        <Link to="/">Return Home</Link>
                    </Flex>
                ),
            }}
        </Content>
    );
}
